import script from "./AuthShell.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthShell.vue?vue&type=script&setup=true&lang=js"

import "./AuthShell.vue?vue&type=style&index=0&id=14ede907&lang=css"

const __exports__ = script;

export default __exports__